import React from "react";
import "./timing.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Calendar, Card,Spin } from "antd";
import moment from "moment";
import { LeftOutlined, RightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";

class timing extends React.Component {
  state = {
    loading:true,
    events: {},
    currentDate: moment(),
    selectedDate: null,
    viewMode: "month",
    user:this.props.location.state?this.props.location.state.data?this.props.location.state.data.user:this.props.currentUser.user.id:this.props.currentUser.user.id,
    myEvents:this.props.location.state?this.props.location.state.data?this.props.location.state.data.myEvents:true:true
  };
  constructor(props) {
    super(props);
    this.getEvents(moment(),this.state.user)
    window.scrollTo(0, 0);
    if (this.props.isRTL) {
      allStrings.setLanguage("ar");
    } else {
      allStrings.setLanguage("en");
    }
  }

  componentDidMount() {
    if (this.props.isRTL) {
      allStrings.setLanguage("ar");
    } else {
      allStrings.setLanguage("en");
    }
  }
  getEvents = (currentDate,user) => {
    axios.get(`${BASE_END_POINT}calendarEvents/get?user=${user}&myEvents=${this.state.myEvents}&year=${currentDate.year()}&month=${currentDate.month()+1}`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("events",response.data.data)
      let events = {
        ...this.state.events,
        ...response.data.data,
      };
      this.setState({events:events,loading:false})
    })
    .catch(error=>{
      console.log("ALL events ERROR")
      console.log(error.response)
    })
  }

  dateFullCellRender = (value) => {
    const dateKey = moment(value).locale("en").format("YYYY-MM-DD");
    const listData = this.state.events[dateKey] || [];
    const isToday = moment().isSame(value, "day");

    return (
      <div
        className={`custom-cell ${isToday ? "today" : ""} ${listData.length > 0 ? "has-event" : ""}`}
        onClick={() => this.setState({ selectedDate: value, viewMode: "day" })}
      >
        <div className="day-number">{value.date()}</div>

        {listData.length > 0 && (
          <div className="events">
            <div
                className="event-item"
                style={{
                  marginBottom: 4,
                  padding: "4px 2px",
                  borderRadius: "6px",
                  background: "#E1F5FF",
                  borderLeft: "3px solid #2DB3E4",
                  fontSize: 11,
                  textAlign: "center",
                }}
              >
                <div style={{ fontWeight: "bold" }}>
                  <span>عدد المهام</span>
                  <p className="events-count">{listData.length}</p>
                  
                </div>
              </div>
          </div>
        )}
      </div>
    );
  };

  renderDayView = () => {
    const { selectedDate, events } = this.state;
    const dateKey = moment(selectedDate).locale("en").format("YYYY-MM-DD");
    const dayEvents = events[dateKey] || [];

    const hours = Array.from({ length: 24 }, (_, i) =>
      moment({ hour: i }).locale("en").format("hh:00 A")
    );

    return (
      <div style={{ padding: "20px 60px" }}>
        <div className="day-header" >
        
          <button
            className="back-button"
            onClick={() => this.setState({ viewMode: "month" })}
          >
            <ArrowLeftOutlined /> رجوع
          </button>
          <h3>{moment(selectedDate).format("dddd, MMMM Do YYYY")}</h3>

        </div>

        <div className="day-timeline" style={{ position: "relative", height: "1440px" }}>
          {hours.map((hour, i) => (
            <div key={i} className="time-slot" style={{ height: "60px" }}>
              <div className="time-label">{hour}</div>
              <div className="slot-line"></div>
            </div>
          ))}

          {dayEvents.map((event, idx) => {
            const [start, end] = event.time.split(" - ");

            // اربط الوقت باليوم المختار
            let startMoment = moment(
              moment(selectedDate).format("YYYY-MM-DD") + " " + start.trim(),
              "YYYY-MM-DD hh:mmA"
            );
            let endMoment = moment(
              moment(selectedDate).format("YYYY-MM-DD") + " " + end.trim(),
              "YYYY-MM-DD hh:mmA"
            );

            // لو النهاية قبل البداية → معناها تاني يوم
            if (endMoment.isSameOrBefore(startMoment)) {
              endMoment.add(1, "day");
            }

            const startTotal = startMoment.hours() * 60 + startMoment.minutes();
            const endTotal = endMoment.hours() * 60 + endMoment.minutes();
            let duration = endTotal - startTotal;

            if (duration <= 0) duration = 60;

            return (
              <div  
                onClick={()=>{
                  event.interest?this.props.history.push("interestInfo",{data:{id:event.interest}}):
                  this.props.history.push("visitingInfo",{data:{id:event.visiting}})
                }} 
                key={idx}
                className="event-block"
                style={{
                  top: `${startTotal}px`,
                  height: `${duration}px`,
                  background:!event.isDone?moment().isAfter(moment(event.toDate), 'minute')?'linear-gradient(135deg, #FF3547, #B71C1C)':'linear-gradient(135deg, #1D9598, #2DB3E4)':'linear-gradient(135deg, #1D9598, #2DB3E4)'
                }}
              >
                <strong>
                  <span style={{
                    display:'inline-block',
                    margin:'0px 10px'
                  }}
                  >{event.time}</span>
                  <span>{event.title}</span>
                </strong>
                <div className="desc">{event.description}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div style={{ minHeight: "100vh", background: "#f5f7fa", padding: "20px" }}>
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{color:'#1D9598'}}>
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol md="12">
                <Card
                  title={allStrings.calendar || "📅 Calendar"}
                  bordered={false}
                  style={{
                    textAlign:this.props.isRTL?"right":"left",
                    borderRadius: "16px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  }}
                >
                  {this.state.viewMode === "month" ? (
                    <div>
                      <div className="calendar-nav">
                        <button
                          className="nav-circle"
                          onClick={() =>{
                            this.setState({
                              loading:true,
                              currentDate: this.state.currentDate.clone().subtract(1, "month"),
                            });
                            this.getEvents(this.state.currentDate.clone().subtract(1, "month"),this.state.user)
                          }}
                        >
                          <LeftOutlined />
                        </button>

                        <span className="month-label">
                          {this.state.currentDate.format("MMMM YYYY")}
                        </span>

                        <button
                          className="nav-circle"
                          onClick={() =>{
                            this.setState({
                              loading:true,
                              currentDate: this.state.currentDate.clone().add(1, "month"),
                            });
                            this.getEvents(this.state.currentDate.clone().add(1, "month"),this.state.user)
                          }}
                        >
                          <RightOutlined />
                        </button>
                      </div>
                      <Calendar
                        dateFullCellRender={this.dateFullCellRender}
                        fullscreen={true}
                        value={this.state.currentDate}
                        headerRender={() => null}
                        onChange={(val) => this.setState({ currentDate: val })}
                        style={{ borderRadius: "12px", background: "#fff" }}
                      />
                    </div>
                  ) : (
                    this.renderDayView()
                  )}
                </Card>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </Spin>
      </div>
    );
  }
}

const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

export default withRouter(connect(mapToStateProps)(timing));
